import React, { useEffect, useState } from "react";

const Topbar = ({ siteSettings }) => {
  const [socialLinks, setSocialLinks] = useState(null);
  useEffect(() => {
    const fetchSiteSettings = async () => {
        try {
            const response = await fetch('https://rss.fastwebforge.com/api/social-links');
            const data = await response.json();
            setSocialLinks(data);
        } catch (error) {
            console.error('Error fetching site settings:', error);
        }
    };

    fetchSiteSettings();
}, []);

let heroSection = null;
if (socialLinks && socialLinks.data && socialLinks.data) {
  heroSection = socialLinks.data[4]
}
const facebook =  heroSection ?  heroSection.site_url : " "

if (socialLinks && socialLinks.data && socialLinks.data) {
  heroSection = socialLinks.data[3]
}
const twitter =  heroSection ?  heroSection.site_url : " "

if (socialLinks && socialLinks.data && socialLinks.data) {
  heroSection = socialLinks.data[2]
}
const instragram =  heroSection ?  heroSection.site_url : " "

if (socialLinks && socialLinks.data && socialLinks.data) {
  heroSection = socialLinks.data[1]
}
const yoytube =  heroSection ?  heroSection.site_url : " "

if (socialLinks && socialLinks.data && socialLinks.data) {
  heroSection = socialLinks.data[0]
}
const linkedIn =  heroSection ?  heroSection.site_url : " "



  return (
    <>
      {/* header Top Start */}
      <div className="hd-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-8">
              <div className="hd-lft">
                <ul>
                  
                  {siteSettings && siteSettings.data ? (
                   <>
                   
                   <a href={`tel:${siteSettings.data.phone}`}>  <li>  <i className="fa fa-phone" /> {siteSettings.data.phone}</li></a>
                   </>
                  ) : (
                    <p></p> // or any fallback message
                  )}

                  
                </ul>
              </div>
            </div>
            <div className="col-md-4 col-sm-4">
              <div className="hd-rgt">
                {/* <span className="follow-title">Follow Us</span> */}
               {/* hbh */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* header Top End */}
    </>
  );
};

export default Topbar;
